<!-- Sin acceso: no hay token -->
<app-no-access *ngIf="hasAccess === false"></app-no-access>

<!-- Comprobando acceso... -->
<div class="app-loading" *ngIf="hasAccess === null">
  <p-progress-spinner ariaLabel="loading" />
</div>

<!-- Aplicación principal -->
<geaui-page-layout *ngIf="hasAccess === true" [headerTemplate]="header" [contentTemplate]="content"
  [sidebarTemplate]="sidebar">
  <ng-template #header>
    <app-header></app-header>
  </ng-template>
  <ng-template #content>
    <div class="spinner" *ngIf="(spinnerService.loading$ | async)">
      <p-progress-spinner ariaLabel="loading" />
    </div>

    <div class="content-body">
      <router-outlet></router-outlet>

    </div>
  </ng-template>
  <ng-template #sidebar>

    <!-- <CHANGE ME> - Change to Icon of your Choice -->
    <geaui-sidebar-v3 [navigationItems]="navItems" [slimView]="true" [adminViewNavigationItems]="adminNavItems"
      [devisionIconPath]="'/assets/icons/GEA-Diagram-Genius-VB-sRGB.svg'" [bottomNavigation]="botItems"
      [devisionName]="title" devisionIconBackgroundColor="var(--geaui-night-blue)">
    </geaui-sidebar-v3>

  </ng-template>
</geaui-page-layout>